<template>
  <app-select
    filter
    :items="states"
    :label="$t('vouchers.purchaseStatus')"
    label-icon="icon-money"
    multiple
    hide-details
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'PurchaseStatusSelect',

  computed: {
    states() {
      return Object.keys(this.$t('vouchers.purchaseStatusOptions')).map((status) => ({
        label: this.$t(`vouchers.purchaseStatusOptions.${status}`),
        value: status
      }));
    }
  }
};
</script>
